const INTERNAL_BASE_URL =
  process.env.REACT_APP_INTERNAL_FUNCTIONS_URL ||
  "https://us-central1-aclymate-internal.cloudfunctions.net";

const postToInternal = async ({ endpoint, body, getIdToken }) => {
  const idToken = await getIdToken();
  if (!idToken) {
    throw new Error("Tester not signed in to aclymate-internal");
  }
  const res = await fetch(`${INTERNAL_BASE_URL}/${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`
    },
    body: JSON.stringify(body || {})
  });
  const rawText = await res.text();
  let data = {};
  try {
    data = rawText ? JSON.parse(rawText) : {};
  } catch {
    data = { _rawText: rawText };
  }
  if (!res.ok) {
    const fallback = data._rawText
      ? `${res.status} ${res.statusText} — ${data._rawText.slice(0, 200)}`
      : `${res.status} ${res.statusText}`;
    const message = data?.message || data?.error || fallback;
    const error = new Error(message);
    error.status = res.status;
    error.code = data?.error || null;
    throw error;
  }
  return data;
};

export const reportBug = ({
  description,
  severity,
  screenshotUrls,
  recorderSnapshot,
  pageUrl,
  clientContext,
  investigateFirst,
  hillId,
  getIdToken
}) =>
  postToInternal({
    endpoint: "reportBug",
    body: {
      description,
      severity,
      screenshotUrls,
      recorderSnapshot,
      pageUrl,
      clientContext,
      investigateFirst: Boolean(investigateFirst),
      ...(hillId ? { hillId } : {})
    },
    getIdToken
  });

export const getActiveTestingHills = ({ getIdToken }) =>
  postToInternal({
    endpoint: "getActiveTestingHills",
    body: {},
    getIdToken
  });

export const getPublicTestingDoc = ({ docId, getIdToken }) =>
  postToInternal({
    endpoint: "getPublicTestingDoc",
    body: { docId },
    getIdToken
  });

export const sendBugMessage = ({ bugId, message, getIdToken }) =>
  postToInternal({
    endpoint: "sendBugMessage",
    body: { bugId, message },
    getIdToken
  });

export const recordTesterEvents = ({ bugId, events, getIdToken }) =>
  postToInternal({
    endpoint: "recordTestingEvent",
    body: { bugId, events },
    getIdToken
  });

export const closeBug = ({ bugId, verdict, note, getIdToken }) =>
  postToInternal({
    endpoint: "closeBug",
    body: { bugId, verdict, note },
    getIdToken
  });

export const claimTesterInvite = ({ getIdToken }) =>
  postToInternal({
    endpoint: "claimTesterInvite",
    body: {},
    getIdToken
  });

export const approveProposal = ({ bugId, confirmConflict, getIdToken }) =>
  postToInternal({
    endpoint: "approveProposal",
    body: { bugId, confirmConflict: Boolean(confirmConflict) },
    getIdToken
  });

export const cancelFix = ({ bugId, getIdToken }) =>
  postToInternal({
    endpoint: "cancelFix",
    body: { bugId },
    getIdToken
  });

export const askCodeQuestion = ({
  question,
  pageUrl,
  clientContext,
  getIdToken
}) =>
  postToInternal({
    endpoint: "askCodeQuestion",
    body: { question, pageUrl, clientContext },
    getIdToken
  });

export const closeQuestion = ({ questionId, getIdToken }) =>
  postToInternal({
    endpoint: "closeQuestion",
    body: { questionId },
    getIdToken
  });

export const reportFeedback = ({
  description,
  category,
  pageUrl,
  clientContext,
  hillId,
  getIdToken
}) =>
  postToInternal({
    endpoint: "reportFeedback",
    body: {
      description,
      pageUrl,
      clientContext,
      ...(category ? { category } : {}),
      ...(hillId ? { hillId } : {})
    },
    getIdToken
  });
